/**
 * The service identity for the CLI connection status.
 * @experimental
 * @internal
 */
export const CliConnectionStatusIdentity = Symbol("CliConnectionStatus");
//# sourceMappingURL=bridgeConnectionStatus.js.map